<template>
  <div class="main-resume">
    <div class="resume-body">
      <div class="resume-top">
        <div class="re-title">
          <h1>个人简历</h1>
          <span>PERSONAL RESUME</span>
        </div>
        <!--<div class="icon">
          <img src="@/assets/image/resume/icon (2).png" />
          <img src="@/assets/image/resume/icon (3).png" />
          <img src="@/assets/image/resume/icon (1).png" />
        </div>-->
      </div>
      <div class="resume-infor">
        <!--基本信息-->
        <div class="infor-title">
          <h1>基本信息</h1>
        </div>
        <div class="base-infor">
          <div class="base-right">
            <img v-if="resume.idPhoto" :src="resume.idPhoto" />
            <img v-else src="@/assets/image/resume/photo.jpg" />
            <h1>个人证件照</h1>
          </div>
          <div class="base-left">
            <ul>
              <li>
                <span class="key"><span class="test">姓名</span></span
                >：<span class="value">{{ resume.realName }}</span>
              </li>
              <li>
                <span class="key"><span class="test">性别</span></span
                >：<span class="value">{{ resume.sex }}</span>
              </li>
              <li>
                <span class="key"><span class="test">出生日期</span></span
                >：<span class="value">{{ resume.birthday }}</span>
              </li>
              <li>
                <span class="key"><span class="test">民族</span></span
                >：<span class="value">{{ resume.nationality }}</span>
              </li>
              <li>
                <span class="key"><span class="test">证件号码</span></span
                >：<span class="value">{{ resume.idNumber }}</span>
              </li>
              <li>
                <span class="key"><span class="test">联系电话</span></span
                >：<span class="value">{{ resume.mphone }}</span>
              </li>
              <li>
                <span class="key"><span class="test">邮箱</span></span
                >：<span class="value">{{ resume.email }}</span>
              </li>
              <li>
                <span class="key"><span class="test">政治面貌</span></span
                >：<span class="value">{{ resume.politicalStatus }}</span>
              </li>
              <li>
                <span class="key"><span class="test">居住地</span></span
                >：<span class="value">{{ resume.address }}</span>
              </li>
              <li>
                <span class="key"><span class="test">毕业学校</span></span
                >：<span class="value">{{ resume.graduateSchool }}</span>
              </li>
              <li>
                <span class="key"><span class="test">学历</span></span
                >：<span class="value">{{ resume.education }}</span>
              </li>
              <li>
                <span class="key"><span class="test">专业</span></span
                >：<span class="value">{{ resume.major }}</span>
              </li>
              <li>
                <span class="key"><span class="test">工作年限</span></span
                >：<span class="value">{{ resume.workYear }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="infor-title">
          <h1>掌握技能</h1>
        </div>
        <div class="base-infor">
          <div class="base-left">
            <ul>
              <li>
                <span class="key"><span class="test">语言类型</span></span
                >：<span class="value">{{ resume.languages }}</span>
              </li>
              <li>
                <span class="key"><span class="test">语言水平</span></span
                >：<span class="value">{{ resume.languageProficiency }}</span>
              </li>
              <li>
                <span class="key"><span class="test">计算机水平</span></span
                >：<span class="value">{{ resume.computerSkills }}</span>
              </li>
              <li>
                <span class="key"><span class="test">计算机等级</span></span
                >：<span class="value">{{ resume.computerGrade }}</span>
              </li>
              <li>
                <span class="key"><span class="test">掌握语言</span></span
                >：<span class="value">{{ resume.computerLanguages }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="infor-title">
          <h1>自我评价</h1>
        </div>
        <div class="base-infor">
          <div class="base-left">
            <ul>
              <li>
                <span class="value">{{ resume.selfAssessment || "暂无" }}</span>
              </li>
            </ul>
          </div>
        </div>
        <!--教育经历-->
        <div class="infor-title not-first-title">
          <h1>教育经历</h1>
        </div>
        <div class="edu-ex">
          <template
            v-if="resume.educationList && resume.educationList.length > 0"
          >
            <div v-for="education in resume.educationList" class="school">
              <ul>
                <li>{{ education.school }}</li>
                <li>{{ education.education }}-{{ education.major }}</li>
                <li>{{ education.year }}</li>
              </ul>
              <p>◉&nbsp;其他：{{ education.serve }}</p>
              <template
                v-if="
                  education.uploadEducationAnnex &&
                    education.uploadEducationAnnex.length > 0
                "
              >
                <h2>◈&nbsp;学历附件</h2>
                <div class="files">
                  <image-uploader
                    v-model="education.uploadEducationAnnex"
                    preview
                    :width="100"
                    :height="140"
                  ></image-uploader>
                </div>
              </template>
              <template v-else>
                <h2>◈&nbsp;学历附件：暂无</h2>
              </template>
            </div>
          </template>
          <template v-else>
            暂无
          </template>
        </div>
        <!--实习经历-->
        <div class="infor-title not-first-title">
          <h1>实习经历</h1>
        </div>
        <div class="edu-ex">
          <template
            v-if="resume.internshipList && resume.internshipList.length > 0"
          >
            <div
              v-for="internship in resume.internshipList"
              class="school work"
            >
              <ul>
                <li>{{ internship.companyName }}</li>
                <li>{{ internship.position }}</li>
                <li>{{ internship.department }}</li>
                <li>{{ internship.startTime }}至{{ internship.endTime }}</li>
              </ul>
              <p>◉&nbsp;工作描述：{{ internship.workContent }}</p>
            </div>
          </template>
          <template v-else>
            暂无
          </template>
        </div>
        <!--工作经历-->
        <div class="infor-title not-first-title">
          <h1>工作经历</h1>
        </div>
        <div class="edu-ex">
          <template v-if="resume.workList && resume.workList.length > 0">
            <div v-for="work in resume.workList" class="school work">
              <ul>
                <li>{{ work.companyName }}</li>
                <li>{{ work.position }}</li>
                <li>{{ work.department }}</li>
                <li>{{ work.startTime }}至{{ work.endTime }}</li>
              </ul>
              <p>◉&nbsp;单位性质：{{ work.companyType }}</p>
              <p>◉&nbsp;行业类别：{{ work.tradeType }}</p>
              <p>◉&nbsp;工作描述：{{ work.workContent }}</p>
            </div>
          </template>
          <template v-else>
            暂无
          </template>
        </div>
        <!--项目经验-->
        <div class="infor-title not-first-title">
          <h1>职业业绩</h1>
        </div>
        <div class="edu-ex">
          <template v-if="resume.projectList && resume.projectList.length > 0">
            <div
              v-for="project in resume.projectList"
              class="school work pro-li"
            >
              <ul>
                <li>{{ project.projectName }}</li>
                <li>{{ project.startTime }}至{{ project.endTime }}</li>
                <li></li>
              </ul>
              <p>◉&nbsp;责任描述：{{ project.projectDuty }}</p>
              <p>◉&nbsp;业绩成果：{{ project.projectResult }}</p>
              <p>◉&nbsp;业绩描述：{{ project.projectAbout }}</p>
            </div>
          </template>
          <template v-else>
            暂无
          </template>
        </div>
        <!--培训信息-->
        <div class="infor-title not-first-title">
          <h1>培训信息</h1>
        </div>
        <div class="edu-ex">
          <template
            v-if="resume.trainingList && resume.trainingList.length > 0"
          >
            <div
              v-for="training in resume.trainingList"
              class="school work pro-li"
            >
              <ul>
                <li>{{ training.trainingCompany }}</li>
                <!--                <li>{{ training.startTime }}至{{ training.endTime }}</li>-->
                <li></li>
              </ul>
              <p>◉&nbsp;科目名称：{{ training.courseName }}</p>
              <p>◉&nbsp;培训等级：{{ training.trainingLevel }}</p>
              <!--              <p>◉&nbsp;培训内容：{{ training.trainingContent }}</p>-->
              <p>◉&nbsp;证书编号：{{ training.certificateNo }}</p>
              <p>◉&nbsp;证件类型：{{ training.certificateType }}</p>
              <p>◉&nbsp;培训学时：{{ training.trainingHours }}</p>
              <p>◉&nbsp;评定成绩：{{ training.achievements }}</p>
              <template
                v-if="
                  training.uploadProof &&
                    training.uploadProof.length > 0
                "
              >
                <h2>◈&nbsp;培训证明</h2>
                <div class="files">
                  <image-uploader
                    v-model="training.uploadProof"
                    preview
                    :width="100"
                    :height="140"
                  ></image-uploader>
                </div>
              </template>
              <template v-else>
                <h2>◈&nbsp;培训证明：暂无</h2>
              </template>
            </div>
          </template>
          <template v-else>
            暂无
          </template>
        </div>
        <!--所获荣誉-->
        <div class="infor-title not-first-title">
          <h1>获得证书</h1>
        </div>
        <div class="edu-ex">
          <template
            v-if="resume.certificateList && resume.certificateList.length > 0"
          >
            <div
              v-for="certificate in resume.certificateList"
              class="school work rongyu"
            >
              <ul>
                <li><span>证书名称</span>{{ certificate.certificateName }}</li>
                <li><span>发放时间</span>{{ certificate.winningTime }}</li>
              </ul>
              <p>◉&nbsp;成绩：{{ certificate.achievements }}</p>
              <template
                v-if="
                  certificate.uploadCertificate &&
                    certificate.uploadCertificate.length > 0
                "
              >
                <h2>◈&nbsp;证书</h2>
                <div class="files">
                  <image-uploader
                    v-model="certificate.uploadCertificate"
                    preview
                    :width="100"
                    :height="140"
                  ></image-uploader>
                </div>
              </template>
              <template v-else>
                <h2>◈&nbsp;证书：暂无</h2>
              </template>
            </div>
          </template>
          <template v-else>
            暂无
          </template>
        </div>
        <!--所获荣誉-->
      </div>
    </div>

    <!--说明-->
    <div class="promise">
      <p>
        本人自愿申请人才库服务，并对上述信息的真实性承担完全责任，同意对相关信息进行针对性审核。
      </p>
    </div>
  </div>
</template>

<script>
import { resume } from "@/api/openApi";
import ImageUploader from "@/components/imageUploader";

export default {
  name: "Resume",
  props: {
    userId: {
      type: String
    },
  },
  // inject: ["reload"],
  components: {
    ImageUploader
  },
  data: function() {
    return {
      resume: {
        idPhoto: "",
        realName: "",
        sex: "",
        birthday: "",
        nationality: "",
        idNumber: "",
        mphone: "",
        email: "",
        politicalStatus: "",
        residence: "",
        graduateSchool: "",
        education: "",
        major: "",
        workYear: "",
        languages: "",
        languageProficiency: "",
        computerSkills: "",
        computerGrade: "",
        computerLanguages: "",
        selfAssessment: "",
        educationList: [],
        internshipList: [],
        workList: [],
        projectList: [],
        trainingList: [],
        certificateList: [],
        honourList: []
      },
      loadingInstance: null
    };
  },
  computed: {},
  watch: {
    userId: {
      handler:function (val) {
        if (val) {
          this.resume = {}
          this.loadResume(val);
        }
      },
      immediate:true
    }
  },
  created() {},
  mounted() {
    // if (this.userId) {
    //   this.loadResume(this.userId);
    // }
  },
  methods: {
    loadResume(userId) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      resume(userId)
        .then(res => {
          if (res.code === 200) {
            if (res.data.educationList && res.data.educationList.length > 0) {
              res.data.educationList.map(item => {
                if (item.uploadEducationAnnex && item.uploadEducationAnnex.length > 0) {
                  item.uploadEducationAnnex = JSON.parse(item.uploadEducationAnnex)[0]
                }
                return item
              })
            }
            if (res.data.certificateList && res.data.certificateList.length > 0) {
              res.data.certificateList.map(item => {
                if (item.uploadCertificate && item.uploadCertificate.length > 0) {
                  item.uploadCertificate = JSON.parse(item.uploadCertificate)[0]
                }
                return item
              })
            }
            if (res.data.trainingList && res.data.trainingList.length > 0) {
              res.data.trainingList.map(item => {
                if (item.uploadProof && item.uploadProof.length > 0) {
                  item.uploadProof = JSON.parse(item.uploadProof)[0]
                }
                return item
              })
            }
            that.resume = res.data;
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
}
.main-resume {
  body {
    color: #333;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    background: #f6f6f6;
  }

  li {
    list-style: none;
  }

  a {
    text-decoration: none;
  }

  @media screen and (min-width: 200px) {
    .resume-body {
      max-width: 1000px;
      margin: 0 auto;
      background-color: #fff;
      padding: 20px 15px 0 20px;
    }
    .resume-top {
      max-width: 940px;
      height: 35px;
      margin: 0 auto;
    }
    .resume-top .re-title {
      float: left;
      max-width: 380px !important;
      height: 35px;
      background-color: #6194a7;
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
      margin-left: -20px;
      padding: 0 13px;
    }
    .resume-top .re-title h1 {
      padding: 0;
      margin: 0;
      font-size: 20px;
      color: #fff;
      /*	display: inline-block;*/
      height: 35px;
      line-height: 35px;
      /*padding:10px 0;*/
      max-width: 150px;
      text-align: center;
      font-weight: normal;
      float: left;
      display: table-cell;
      text-align: center;
      vertical-align: middle;
    }
    .resume-top .re-title span {
      font-size: 12px;
      color: #fff;
      display: block;
      float: left;
      line-height: 24px;
      margin-top: 6px;
      border-left: 2px solid #fff;
      padding-left: 5px;
      margin-left: 5px;
    }
    .resume-top .icon {
      float: right;
    }
    .resume-top .icon img {
      width: 32px;
      height: 32px;
      margin: 0px 2px 0 2px;
    }
    .resume-infor {
      max-width: 900px;
      margin: 0 auto;
      padding: 15px 0;
      border-left: 1px solid #ddd;
    }
    .infor-title {
      width: 100%;
      border-top: 1px solid #ddd;
      margin: 30px auto 20px;
    }
    .infor-title h1 {
      width: 130px;
      height: 30px;
      background-color: #6194a7;
      color: #ffffff;
      font-size: 18px;
      color: #fff;
      font-weight: normal;
      text-align: center;
      line-height: 30px;
      border-radius: 30px;
      margin-top: -17px;
      margin-left: -17px;
    }
    .not-first-title {
      margin: 40px auto 20px;
    }
    .base-infor {
      max-width: 800px;
      margin: 0 auto;
    }
    .base-infor .base-left {
      width: 87%;
      display: block;
      margin: 0 auto;
    }
    .base-infor .base-left li {
      list-style: none;
      width: 100%;
      display: inline-block;
      font-size: 16px;
      line-height: 35px;
      border-bottom: 1px dashed #ddd;
      color: #999;
      margin-top: 10px;
    }
    .base-infor .base-left li .key {
      display: inline-block;
      width: 80px;
      height: 35px;
      text-align-last: justify;
      text-align: justify;
      text-justify: distribute-all-lines;
      overflow: hidden;
      float: left;
    }
    .base-infor .base-left li .key .test {
      display: inline-block;
    }
    .base-infor .base-left li .key .test:after {
      display: inline-block;
      content: "";
      width: 80px;
      text-align: justify;
      overflow: hidden;
    }
    .base-infor .base-left li .value {
      display: inline-block;
      margin-left: 10px;
      color: #333;
      /*line-height:40px;*/
    }
    .base-right {
      width: 140px;
      display: block;
      text-align: center;
      margin: 0 auto 10px;
    }
    .base-right img {
      width: 140px;
      margin-top: 5px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .base-right h1 {
      font-weight: normal;
      font-size: 18px;
      margin-top: 10px;
    }

    .edu-ex {
      max-width: 800px;
      margin: 0 auto;
      padding-left: 15px;
    }
    .edu-ex .school:first-child {
      border-top: none;
      padding-top: 0;
      margin-top: 0;
    }
    .edu-ex .school {
      border-top: 1px dashed #ddd;
      padding-top: 10px;
      margin-top: 10px;
    }
    .edu-ex .school li {
      display: inline-block;

      height: 30px;
      font-size: 14px;
      /*color:#6194A7;*/
      font-weight: bold;
      line-height: 20px;
      letter-spacing: 0.02em;
      color: #3f616d;
    }
    .edu-ex .school li:nth-child(2) {
      width: 33%;
      margin: 0;
      text-align: right;
    }
    .edu-ex .school li:first-child {
      width: 65%;
      text-align: left;
    }
    .edu-ex .school li:last-child {
      width: 50%;
      text-align: left;
    }
    .edu-ex .school p {
      display: block;
      max-width: 800px;
      margin: 0px auto 0;
      font-size: 15px;
      line-height: 30px;
    }
    .edu-ex .school h2 {
      display: block;
      max-width: 800px;
      margin: 5px auto 0;
      font-size: 15px;
      line-height: 30px;
      color: #6194a7;
      font-weight: normal;
    }
    .edu-ex .rongyu li:last-child {
      margin-top: 10px;
    }
    .edu-ex .school li span {
      font-size: 15px;
      color: #999;
      font-weight: normal;
      display: block;
      line-height: 25px;
    }
    .edu-ex .school .link-img {
      width: 90px;
      margin: 10px auto 0;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      margin-right: 10px;
    }
    .pro-li li:last-child {
      height: 0;
      float: left;
    }
    .pro-li li:first-child {
      width: 55% !important;
    }
    .pro-li li:nth-child(2) {
      width: 43% !important;
    }
    .edu-ex .files img {
      display: inline-block;
      width: 20px;
      vertical-align: middle;
      margin-right: 5px;
    }
    .edu-ex .files span {
      display: inline-block;
      line-height: 35px;
      color: #999;
    }
  }

  @media screen and (min-width: 1000px) and (max-width: 2000px) {
    .resume-body {
      max-width: 1000px;
      margin: 0 auto;
      background-color: #fff;
      padding: 30px 0 0 20px;
    }
    .resume-top {
      max-width: 940px;
      height: 50px;
      margin: 0 auto;
    }
    .resume-top .re-title {
      float: left;
      width: 340px !important;
      height: 50px;
      background-color: #6194a7;
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
      margin-left: -30px;
      padding: 0px;
    }
    .resume-top .re-title h1 {
      font-size: 26px;
      color: #fff;
      /*display: inline-block;*/
      line-height: 50px;
      width: 150px;
      text-align: center;
      font-weight: normal;
      float: left;
    }
    .resume-top .re-title span {
      font-size: 16px;
      color: #fff;
      display: block;
      float: left;
      height: 30px;
      line-height: 30px;
      margin-top: 10px;
      border-left: 2px solid #fff;
      padding-left: 10px;
      margin-left: 0px;
    }
    .resume-top .icon {
      float: right;
    }
    .resume-top .icon img {
      width: 40px;
      height: 40px;
      margin: 5px 5px;
    }
    .resume-infor {
      width: 900px;
      margin: 0 auto;
      padding: 30px 0;
      border-left: 1px solid #ddd;
    }
    .infor-title {
      width: 100%;
      border-top: 1px solid #ddd;
      margin: 20px auto;
    }
    .infor-title h1 {
      width: 150px;
      height: 35px;
      background-color: #6194a7;
      color: #ffffff;
      font-size: 18px;
      color: #fff;
      font-weight: normal;
      text-align: center;
      line-height: 35px;
      border-radius: 30px;
      margin-top: -17px;
      margin-left: -17px;
    }
    .not-first-title {
      margin: 40px auto 20px;
    }
    .base-infor {
      width: 800px;
      margin: 0 auto;
    }
    .base-infor .base-left {
      width: 620px;
      display: inline-block;
    }
    .base-infor .base-left li {
      list-style: none;
      width: 300px;
      display: inline-block;
      font-size: 16px;
      line-height: 50px;
      border-bottom: 1px dashed #ddd;
      color: #999;
      margin-top: 0px;
    }
    .base-infor .base-left li .key {
      display: inline-block;
      width: 80px;
      text-align-last: justify;
      text-align: justify;
      text-justify: distribute-all-lines;
    }
    .base-infor .base-left li .value {
      display: inline-block;
      margin-left: 10px;
      color: #333;
    }
    .base-right {
      width: 140px;
      float: right;
      text-align: center;
    }
    .base-right img {
      width: 140px;
      margin-top: 30px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .base-right h1 {
      font-weight: normal;
      font-size: 20px;
      margin-top: 20px;
    }
    .edu-ex {
      max-width: 800px;
      margin: 0 auto;
    }
    .edu-ex .school:first-child {
      border-top: none;
      padding-top: 0;
      margin-top: 0;
    }
    .edu-ex .school {
      border-top: 1px dashed #ddd;
      padding-top: 10px;
      margin-top: 10px;
    }
    .edu-ex .school li {
      display: inline-block;

      height: 35px;
      font-size: 16px;
      /*color:#6194A7;*/
      font-weight: bold;
      line-height: 35px;
      letter-spacing: 0.02em;
      color: #3f616d;
    }
    .edu-ex .school li:nth-child(2) {
      max-width: 240px;
      margin: 0 30px;
      text-align: center;
    }
    .edu-ex .school li:first-child {
      max-width: 240px;
      text-align: left;
    }
    .edu-ex .school li:last-child {
      max-width: 240px;
      text-align: right;
    }
    .edu-ex .school p {
      display: block;
      max-width: 800px;
      margin: 10px auto 0;
      font-size: 16px;
      line-height: 30px;
    }
    .edu-ex .school h2 {
      display: block;
      max-width: 800px;
      margin: 5px auto 0;
      font-size: 16px;
      line-height: 30px;
      color: #6194a7;
      font-weight: normal;
    }
    .edu-ex .school li span {
      font-size: 16px;
      color: #999;
      font-weight: normal;
      display: block;
      line-height: 35px;
    }
    .edu-ex .school .link-img {
      width: 100px;
      margin: 10px auto 0;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
      margin-right: 10px;
    }
    .pro-li li:last-child {
      height: 0;
      float: left;
    }
    .pro-li li:nth-child(2) {
      float: right;
      margin: 0 !important;
      text-align: right !important;
    }
    .edu-ex .rongyu li:last-child {
      margin-top: 0px;
    }
    .edu-ex .files img {
      display: inline-block;
      width: 20px;
      vertical-align: middle;
      margin-right: 5px;
    }
    .edu-ex .files span {
      display: inline-block;
      line-height: 35px;
      color: #999;
    }
  }

  a {
    text-decoration: none;
  }

  a:link {
    color: #3f616d;
  }

  a:visited {
    color: #3f616d;
  }

  a:hover {
    color: #3f616d;
  }

  a:active {
    color: #3f616d;
  }

  .test-inter {
    max-width: 800px;
    margin: 0 auto;
    padding-left: 15px;
  }

  .test-inter table {
    max-width: 800px;
  }

  @media screen and (min-width: 200px) {
    .test-inter table th {
      width: 33%;
      text-align: center;
      height: 25px;
      font-size: 15px;
      color: #999;
      font-weight: normal;
      line-height: 25px;
      padding: 5px;
      border-bottom: 1px dashed #e5e5e5;
    }
    .test-inter table th:first-child {
      text-align: left;
    }
    .test-inter table th:last-child {
      text-align: right;
    }
    .test-inter table td {
      width: 33%;
      padding: 5px;
      text-align: center;
      height: 50px;
      font-size: 14px;
      /* color: #6194A7; */
      font-weight: bold;
      /* line-height: 40px;*/
      letter-spacing: 0.02em;
      color: #3f616d;
      border-bottom: 1px dashed #e5e5e5;
    }
    .test-inter table td:first-child {
      text-align: left;
    }
    .test-inter table td:last-child {
      text-align: right;
    }

    /*<!--说明-->*/
    .promise {
      max-width: 1020px;
      margin: 0 auto;
      background-color: #6194a7;
      padding: 10px 0;
    }
    .promise p {
      padding: 0 10px 0 15px;
      font-size: 12px;
      line-height: 24px;
      color: #fff;
      text-indent: 2em;
    }
  }
  @media screen and (min-width: 1000px) and (max-width: 2000px) {
    .test-inter table th {
      width: 265px;
      text-align: center;
      height: 30px;
      font-size: 16px;
      color: #999;
      font-weight: normal;
      line-height: 35px;
      border: none;
    }
    .test-inter table th:first-child {
      text-align: left;
    }
    .test-inter table th:last-child {
      text-align: right;
    }
    .test-inter table td {
      text-align: center;
      height: 40px;
      font-size: 16px;
      /* color: #6194A7; */
      font-weight: bold;
      line-height: 40px;
      letter-spacing: 0.02em;
      color: #3f616d;
    }
    .test-inter table td:first-child {
      text-align: left;
    }
    .test-inter table td:last-child {
      text-align: right;
    }

    /*<!--说明-->*/
    .promise {
      max-width: 1020px;
      margin: 0 auto;
      background-color: #6194a7;
      padding: 10px 0;
    }
    .promise p {
      padding: 0 80px 0 90px;
      font-size: 14px;
      line-height: 24px;
      color: #fff;
      text-indent: 2em;
    }
  }
}
</style>
